module.exports = __webpack_public_path__ + "static/media/placed.ed17ca2a.svg";